import React from 'react'
import { RenderCurrency, RenderDollar } from '../../../../../Utils/renderField/renderReadField';
import './BonifTotalesResumen.css';

/**
 * Componente que muestra un resumen de las bonificaciones totales.
 * @param {Object} props - Props del componente.
 * @param {number} props.total_bonif_nh3 - Total de bonificación por NH3.
 * @param {number} props.total_bonif_nh3_quetzales - Total de bonificación por NH3 en quetzales.
 * @param {number} props.total_bonif_fletes - Total de bonificación por fletes.
 * @param {number} props.total_bonif_fletes_quetzales - Total de bonificación por fletes en quetzales.
 * @param {number} props.total_dolares - Total en dólares.
 * @param {number} props.total_quetzales - Total en quetzales.
 * @returns {JSX.Element} - Componente de resumen de bonificaciones totales.
 */
const BonifTotalesResumen = (props) => {
    const {
        total_bonif_nh3,
        total_bonif_nh3_quetzales,
        total_bonif_fletes,
        total_bonif_fletes_quetzales,
        total_dolares,
        total_quetzales,
        recepcionesNH3,
        recepcionesFletes,
    } = props;

    const total_bonificaciones = total_bonif_nh3 + total_bonif_fletes;
    const total_bonificaciones_quetzales = total_bonif_nh3_quetzales + total_bonif_fletes_quetzales;

    return (
        <div>
            <div className="row col-12 m-0 py-1 d-flex flex-wrap justify-content-center mt-4 mb-1">
                <div className="new-table-wrapper bonif-totales-resumen__table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th colSpan={3}>BONIFICACIONES</th>
                            </tr>
                            <tr>
                                <th>CONCEPTO BONIFICACIÓN</th>
                                <th>BONIFICACIÓN ($)</th>
                                <th>BONIFICACIÓN (Q)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recepcionesNH3 && recepcionesNH3.length > 0 && (
                                <tr>
                                    <td className='text-center font-weight-bold'>Uso de Amoniaco</td>
                                    <td className='td--right'>
                                        <RenderDollar value={total_bonif_nh3} decimalScale={4} />
                                    </td>
                                    <td className='td--right'>
                                        <RenderCurrency value={total_bonif_nh3_quetzales} decimalScale={4} />
                                    </td>
                                </tr>
                            )}
                            {recepcionesFletes && recepcionesFletes.length > 0 && (
                                <tr>
                                    <td className='text-center font-weight-bold'>Costo de Flete</td>
                                    <td className='td--right'>
                                        <RenderDollar value={total_bonif_fletes} decimalScale={4} />
                                    </td>
                                    <td className='td--right'>
                                        <RenderCurrency value={total_bonif_fletes_quetzales} decimalScale={4} />
                                    </td>
                                </tr>
                            )}
                            <tr className='bonif-totales-resumen__fila-total'>
                                <td className='text-center font-weight-bold'>TOTAL</td>
                                <td className='td--right'>
                                    <RenderDollar value={total_bonificaciones} decimalScale={4} />
                                </td>
                                <td className='td--right'>
                                    <RenderCurrency value={total_bonificaciones_quetzales} decimalScale={4} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row col-12 m-0 py-1 d-flex flex-wrap justify-content-center mt-3 mb-3">
                <div className="new-table-wrapper bonif-totales-resumen__table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th colSpan={2}>TOTAL + BONIFICACIONES</th>
                            </tr>
                            <tr>
                                <th>TOTAL DÓLARES</th>
                                <th>TOTAL QUETZALES</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='bonif-totales-resumen__fila-total'>
                                <td className='text-center font-weight-bold'>
                                    <RenderDollar value={total_dolares} decimalScale={2} />
                                </td>
                                <td className='text-center font-weight-bold'>
                                    <RenderCurrency value={total_quetzales} decimalScale={2} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default BonifTotalesResumen;
